/**
 * The `--adland-*` custom properties the card reads. Custom properties inherit
 * through the shadow boundary automatically (inline mode), but NOT across an
 * iframe document boundary — so for isolated mode we read whichever of these
 * are set on the host and copy them into the iframe's `:root`.
 */
export const THEME_VARS = [
  "--adland-bg",
  "--adland-fg",
  "--adland-muted",
  "--adland-label",
  "--adland-border",
  "--adland-border-hover",
  "--adland-border-width",
  "--adland-radius",
  "--adland-padding",
  "--adland-bleed",
  "--adland-gap",
  "--adland-font",
  "--adland-shadow",
  "--adland-shadow-hover",
  "--adland-transform-hover",
  "--adland-transition",
  "--adland-media-size",
  "--adland-media-radius",
  "--adland-media-bg",
  "--adland-title-size",
  "--adland-title-weight",
  "--adland-description-size",
  "--adland-media-border",
  "--adland-label-size",
] as const;

/**
 * Serialize the theme custom properties currently set on `host` into a CSS
 * declaration string (e.g. `--adland-bg:#000;`). Empty when none are set.
 */
export function readThemeVars(host: Element): string {
  const styles = getComputedStyle(host);
  let out = "";
  for (const name of THEME_VARS) {
    const value = styles.getPropertyValue(name).trim();
    if (value) out += `${name}:${value};`;
  }
  return out;
}
